module.exports = {"name":"ZHONGDU | 中都","description":"ZHONGDU IS AN ARCHITECTURE AND LANDSCAPE STUDIO FOUNDED IN 2020 BY DE QIAN HUANG AND ZEQI LIU."}